<div class="consent-container d-flex">
    <i class="btn-close icon-edponline-Bop-071" [ngClass]="{'pt-3-sa': isApp}" *ngIf="data.showClose" data-modal="dismiss()"
        (click)="closeModal(false)"  aria-hidden="true"></i>
    <ng-container *ngIf="!sucessFormSend">
        <!-- DEFAULT FORM -->
        <div class="sidebar">
            <span class="header-title">{{ 'pt.edp.edponline.consent.title' | translate }}</span>
            <p [innerHTML]="'pt.edp.edponline.consent.description' | translate "></p>
        </div>
        <div class="consent-container-wrapper">
            <form [formGroup]="form" (ngSubmit)="submitForm()">
                <div class="consent-info-container">
                    <div class="w-100">
                        <p class="w-100 question">
                            {{ 'pt.edp.edponline.consent.first_question' | translate }}?
                        </p>
                        <div class="radio-wrapper w-100" formGroupName="invoiceAdvicesGroup">
                            <label for="invoiceAdvices-1" class="custom-radio-button-label">
                                <input id="invoiceAdvices-1" type="radio" value="S" formControlName="invoiceAdvices" class="custom-radio-button-input"/>
                                <span class="custom-radio-button-mark" [ngClass]="{ 'error' :  formSubmitted && form.controls.invoiceAdvicesGroup.status === 'INVALID' }"></span>
                                <span [ngClass]="{ 'error' :  formSubmitted && form.controls.invoiceAdvicesGroup.status === 'INVALID' }">
                                    {{ 'pt.edp.edponline.common.yes' | translate }}
                                </span>                            </label>
                            <label for="invoiceAdvices-2" class="custom-radio-button-label">
                                <input id="invoiceAdvices-2" type="radio" value="N" formControlName="invoiceAdvices" class="custom-radio-button-input"/>
                                <span class="custom-radio-button-mark" [ngClass]="{ 'error' :  formSubmitted && form.controls.invoiceAdvicesGroup.status === 'INVALID' }"></span>
                                <span [ngClass]="{ 'error' :  formSubmitted && form.controls.invoiceAdvicesGroup.status === 'INVALID' }">
                                    {{ 'pt.edp.edponline.common.no' | translate }}
                                </span>
                            </label>
                        </div>
                        <span class="w-100 info">
                            {{ 'pt.edp.edponline.consent.first_question.info' | translate }}
                        </span>
                    </div>
                    <div class="w-100">
                        <p class="w-100 question">
                            {{ 'pt.edp.edponline.consent.second_question' | translate }}?
                        </p>
                        <div class="radio-wrapper w-100" formGroupName="partnershipDiscountsGroup">
                            <label for="partnershipDiscounts-1" class="custom-radio-button-label">
                                <input id="partnershipDiscounts-1" type="radio" value="S" formControlName="partnershipDiscounts" class="custom-radio-button-input"/>
                                <span class="custom-radio-button-mark" [ngClass]="{ 'error' :  formSubmitted && form.controls.partnershipDiscountsGroup.status === 'INVALID' }"></span>
                                <span [ngClass]="{ 'error' :  formSubmitted && form.controls.partnershipDiscountsGroup.status === 'INVALID' }">{{ 'pt.edp.edponline.common.yes' | translate }}</span>
                            </label>
                            <label for="partnershipDiscounts-2" class="custom-radio-button-label">
                                <input id="partnershipDiscounts-2" type="radio" value="N" formControlName="partnershipDiscounts" class="custom-radio-button-input"/>
                                <span class="custom-radio-button-mark" [ngClass]="{ 'error' :  formSubmitted && form.controls.partnershipDiscountsGroup.status === 'INVALID'}"></span>
                                <span [ngClass]="{ 'error' :  formSubmitted && form.controls.partnershipDiscountsGroup.status === 'INVALID' }">{{ 'pt.edp.edponline.common.no' | translate }}</span>
                            </label>
                        </div>
                        <span class="w-100 info">
                            {{ 'pt.edp.edponline.consent.second_question.info' | translate }}
                        </span>
                    </div>
                    <div class="w-100">
                        <p class="w-100">
                            {{ 'pt.edp.edponline.consent.third_question' | translate }}?
                        </p>
                        <div class="w-100" formGroupName="afterContractGroup">
                            <label for="afterContract-1" class="custom-radio-button-label">
                                <input id="afterContract-1" type="radio" value="S" formControlName="afterContract" class="custom-radio-button-input"/>
                                <span class="custom-radio-button-mark" [ngClass]="{ 'error' :  formSubmitted && form.controls.afterContractGroup.status === 'INVALID' }"></span>
                                <span [ngClass]="{ 'error' :  formSubmitted && form.controls.afterContractGroup.status === 'INVALID' }">{{ 'pt.edp.edponline.common.yes' | translate }}</span>
                            </label>
                            <label for="afterContract-2" class="custom-radio-button-label">
                                <input id="afterContract-2" type="radio" value="N" formControlName="afterContract" class="custom-radio-button-input"/>
                                <span class="custom-radio-button-mark" [ngClass]="{ 'error' :  formSubmitted && form.controls.afterContractGroup.status === 'INVALID' }"></span>
                                <span [ngClass]="{ 'error' :  formSubmitted && form.controls.afterContractGroup.status === 'INVALID' }">{{ 'pt.edp.edponline.common.no' | translate }}</span>
                            </label>
                        </div>
                        <span class="w-100 info">
                            {{ 'pt.edp.edponline.consent.third_question.info' | translate }}
                        </span>
                    </div>
                </div>
                <div class="consent-footer">
                    <span [innerHTML]="'pt.edp.edponline.consent.legend' | translate ">
                    </span>
                    <button [disabled]=!form.valid class="btn btn-primary submit-button text-uppercase" type="submit">
                        {{ 'pt.edp.edponline.consent.submit_button' | translate }}
                    </button>
                </div>
            </form>
        </div>
    </ng-container>
    <ng-container *ngIf="sucessFormSend">
        <div class="success-text-wrapper">
            <div class="success-text">
                <h1>{{ 'pt.edp.edponline.consent.thanks.title' | translate }}</h1>
                <p [innerHTML]="'pt.edp.edponline.consent.thanks.description' | translate "></p>
            </div>
        </div>
        <div class="success-figure">
            <figure>
                <img [src]="thanksImage" alt="" />
            </figure>
        </div>
    </ng-container>
</div>